import React from "react";
import { motion } from "framer-motion";
import { FiCode, FiServer, FiSmartphone, FiDatabase, FiCloud, FiGitBranch, FiBarChart2, FiCpu } from "react-icons/fi";

function TechnologyStack() {
  const techStack = [
    { title: "Programming Languages", items: ["C/C++", "Java", "JavaScript", "Python", "PHP"], icon: <FiCode className="text-green-400 w-12 h-12 mx-auto mb-4" /> },
    { title: "Web Development", items: ["Frontend", "Backend"], icon: <FiServer className="text-blue-400 w-12 h-12 mx-auto mb-4" /> },
    { title: "Mobile App Development", items: ["Flutter", "React Native", "Swift (iOS)"], icon: <FiSmartphone className="text-pink-400 w-12 h-12 mx-auto mb-4" /> },
    { title: "Databases", items: ["Relational Database", "NoSQL Database"], icon: <FiDatabase className="text-yellow-400 w-12 h-12 mx-auto mb-4" /> },
    { title: "Cloud Platforms", items: ["AWS", "Microsoft Azure", "Google Cloud Platform"], icon: <FiCloud className="text-purple-400 w-12 h-12 mx-auto mb-4" /> },
    { title: "DevOps", items: ["GitHub Actions", "Docker", "Kubernetes"], icon: <FiGitBranch className="text-red-400 w-12 h-12 mx-auto mb-4" /> },
    { title: "Data Analytics", items: ["Tableau", "Power BI", "SQL", "MS Excel", "Statistics"], icon: <FiBarChart2 className="text-indigo-400 w-12 h-12 mx-auto mb-4" /> },
    { title: "Machine Learning", items: ["Machine Learning Algorithms"], icon: <FiCpu className="text-orange-400 w-12 h-12 mx-auto mb-4" /> },
  ];

  return (
  <div className="py-20 bg-black min-h-screen">
    <div className="max-w-7xl mx-auto text-center">

      {/* Heading */}
      <motion.h1
        className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4 
        bg-clip-text text-transparent 
        bg-gradient-to-r from-[#C5A46D] via-[#E7C787] to-[#C5A46D]"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: false }}
      >
        Our Technology Stack
      </motion.h1>

      <motion.p
        className="text-gray-300 text-lg md:text-xl mb-12 max-w-2xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.3 }}
        viewport={{ once: false }}
      >
        We leverage the most advanced and reliable technologies to deliver top-notch solutions.
      </motion.p>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {techStack.map((tech, idx) => (
          <motion.div
            key={idx}
            className="bg-black/70 backdrop-blur-xl p-6 rounded-2xl shadow-lg 
            border border-[#D4AF37]/30 hover:border-[#D4AF37]/80 
            transition-all duration-300 cursor-pointer"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: idx * 0.2 }}
            viewport={{ once: false }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 15px 30px rgba(212, 175, 55, 0.4)",
            }}
          >
            {tech.icon}

            <h3 className="text-xl md:text-2xl font-bold 
            bg-clip-text text-transparent 
            bg-gradient-to-r from-[#E5C07B] to-[#F6E7C1] mb-3">
              {tech.title}
            </h3>

            <ul className="mt-2 text-sm md:text-base text-gray-300 space-y-1">
              {tech.items.map((item, i) => (
                <li
                  key={i}
                  className="hover:text-[#D4AF37] transition-colors duration-300"
                >
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  </div>
);

}

export default TechnologyStack;
